import { CSSObject } from 'foundations-theming/utils';
import { Theme } from 'foundations-theming';
import { LinkUse } from './Link';

const getIconColorForUse = (
  use: LinkUse,
  disabled: boolean,
  theme: Theme
): string | undefined => {
  if (disabled) {
    return 'inherit';
  }

  switch (use) {
    case 'on-dark':
      return theme.color['icon-interactive-on-fill-default'];
    case 'on-bright':
      return theme.color['icon-core-default'];
    case 'on-fill':
      return theme.color['specialty-link-on-fill-default'];
    case 'blue':
    case 'dark':
    case 'light':
    case 'mention':
      return theme.color['icon-interactive-default'];
    case 'danger':
      return theme.color['icon-alert-default'];
    case 'unstyled':
      return undefined; // No color override for unstyled.
    default: {
      const __exhaustiveCheck: never = use;
      throw new Error(`Unhandled \`use\` argument: ${use}`);
    }
  }
};

export const getLinkIconStyles = (
  use: LinkUse,
  disabled: boolean,
  theme: Theme
): CSSObject => {
  const color = getIconColorForUse(use, disabled, theme);

  return {
    verticalAlign: '-0.25em',
    ...(color && { color }),
  };
};

/**
 * Computes the final link use based on the provided use and toolbar context.
 */
export const getComputedLinkUse = ({
  use,
  isInFilledToolbar,
}: {
  use: LinkUse;
  isInFilledToolbar: boolean;
}): LinkUse => {
  // because we're no longer clobbering link styles in toolbars, this needs to work across themes
  if (isInFilledToolbar) {
    // Always use on-fill in a filled toolbar unless it's danger
    if (use === 'danger') {
      return use;
    }
    return 'on-fill';
  }
  return use;
};
